import { render, staticRenderFns } from "./cardTemplateVip14.vue?vue&type=template&id=123cdbb4&scoped=true&"
import script from "./cardTemplateVip14.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip14.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip14.vue?vue&type=style&index=0&id=123cdbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123cdbb4",
  null
  
)

export default component.exports